module.exports = __webpack_public_path__ + "static/media/SPEDIDAM-LOGO-RVB_Negatif.4301af9f.svg";